var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.status === _vm.SORT_CARET_STATUS.INIT ? _c('span', {
    staticClass: "d-flex flex-column position-relative"
  }, [_c('BIconCaretUpFill', {
    staticStyle: {
      "position": "absolute",
      "top": "-5px"
    },
    attrs: {
      "size": "sm"
    }
  }), _c('BIconCaretDownFill', {
    staticStyle: {
      "position": "relative",
      "top": "5px"
    },
    attrs: {
      "icon": "caret-down-fill",
      "size": "sm"
    }
  })], 1) : _vm.status === _vm.SORT_CARET_STATUS.DESC ? _c('span', {
    staticClass: "d-flex flex-column position-relative"
  }, [_c('BIconCaretUpFill', {
    staticStyle: {
      "position": "absolute",
      "top": "-5px"
    },
    attrs: {
      "size": "sm"
    }
  }), _c('BIconCaretDownFill', {
    staticClass: "active",
    staticStyle: {
      "position": "relative",
      "top": "5px"
    },
    attrs: {
      "size": "sm"
    }
  })], 1) : _vm.status === _vm.SORT_CARET_STATUS.ASC ? _c('span', {
    staticClass: "d-flex flex-column position-relative"
  }, [_c('BIconCaretUpFill', {
    staticClass: "active",
    staticStyle: {
      "position": "absolute",
      "top": "-5px"
    },
    attrs: {
      "size": "sm"
    }
  }), _c('BIconCaretDownFill', {
    staticStyle: {
      "position": "relative",
      "top": "5px"
    },
    attrs: {
      "icon": "caret-down-fill",
      "size": "sm"
    }
  })], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }